/* ==========================================================================
   FOOTBALL-THEME :: Mobile bottom dock behaviour
   Proxies Menu / Search / Cart taps to the site's existing controls: the
   custom header burger, Dawn's search-modal summary and the #cart-icon-bubble
   cart-drawer trigger. Everything else is a plain link. Vanilla JS, no
   dependencies; the custom element upgrades automatically when the section is
   re-rendered by the theme editor (shopify:section:load).
   ========================================================================== */
(function () {
  'use strict';

  function clickFirst(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var element = document.querySelector(selectors[i]);
      if (element) {
        element.click();
        return true;
      }
    }
    return false;
  }

  if (!customElements.get('football-dock')) {
    customElements.define(
      'football-dock',
      class FootballDock extends HTMLElement {
        connectedCallback() {
          if (this.dataset.fsDockReady === 'true') return;
          this.dataset.fsDockReady = 'true';
          this.addEventListener('click', this.onClick.bind(this));
        }

        onClick(event) {
          var target = event.target instanceof Element ? event.target : null;
          var trigger = target ? target.closest('[data-fs-dock-action]') : null;
          if (!trigger || !this.contains(trigger)) return;

          var action = trigger.getAttribute('data-fs-dock-action');

          if (action === 'menu') {
            event.preventDefault();
            clickFirst([
              '.fs-header__burger',
              '.menu-drawer-button',
              '[aria-controls="menu-drawer"]'
            ]);
          } else if (action === 'search') {
            event.preventDefault();
            clickFirst([
              '.fs-header__icons .header__icon--search',
              '.header__icons details-modal summary',
              '.fs-header__icons details-modal summary'
            ]);
          } else if (action === 'cart') {
            var bubble = document.querySelector('#cart-icon-bubble');
            if (bubble) {
              event.preventDefault();
              bubble.click();
            }
          }
        }
      }
    );
  }
})();
